import { useState, useEffect } from 'react'

import Dialog from './Dialog'
import GridCheckbox from './GridCheckbox'
import GridMatchInfo from './GridMatchInfo'
import { titlesCalendari } from '../settings/settings'

const DialogArbitraggio = ({ open, handleClose, triggerFunction, gara }) => {
  const [needsReferee, setNeedsReferee] = useState()

  useEffect(() => {
    setNeedsReferee(gara?.needsReferee)
  }, [gara])

  const info =
    'Il presente modulo permette di indicare se la gara preveda un arbitraggio ufficiale.'

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(needsReferee)}
      title={titlesCalendari.titleEditArbitraggio}
      textConfirm='Salva'
      maxWidth='md'
    >
      <GridMatchInfo gara={gara} info={info}>
        {gara?.requiresReferee ? (
          <GridCheckbox
            label='Arbitraggio richiesto dalla squadra di casa'
            value={!!gara?.requiresReferee}
            md={12}
          />
        ) : (
          <GridCheckbox
            label='Arbitraggio ufficiale'
            value={!!needsReferee}
            onChange={(_, x) => setNeedsReferee(x)}
            md={12}
          />
        )}
      </GridMatchInfo>
    </Dialog>
  )
}

export default DialogArbitraggio
